import { H6, SVG } from "../../../AbstractElements";
import { CommonCurrencyWidgetPropsType } from "../../../Type/WidgetsType";
import CurrencyWidgetCard from "./CurrencyWidgetCard";

const CommonCurrencyWidget = ({ data }: CommonCurrencyWidgetPropsType) => {
  return (
    <div className={`currency-widget height-equal widget-currency ${data.color}`}>
      <div className="d-flex">
        <div className="currency-icon-widget">
          <SVG iconId={data.icon}/>
        </div>
        <div>
          <H6>{data.title} <span className="f-light">{data.sortName}</span></H6>
        </div>
      </div>
      <CurrencyWidgetCard data={data} />
    </div>
  );
};

export default CommonCurrencyWidget;
